/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AmazonTrackingInput = {
  asin: string;
  memo?: string | null | undefined;
  probability?: number | null | undefined;
};

export enum Condition {
  New = 'new',
  Old = 'old'
}

export enum FilterOtherSetting {
  HasIpMemo = 'hasIPMemo',
  HasMemo = 'hasMemo',
  IsPriceDownInCacheRegister = 'isPriceDownInCacheRegister',
  IsSleeped = 'isSleeped'
}

export enum FilterUserProduct {
  All = 'all',
  My = 'my',
  Nonestore = 'nonestore'
}

export enum IrisOrderLevel {
  Direct = 'direct',
  Direct1 = 'direct1',
  Direct3 = 'direct3',
  Direct10 = 'direct10',
  DirectNoneSale = 'directNoneSale',
  DirectOver10 = 'directOver10',
  Discontinued = 'discontinued',
  Fba = 'fba',
  FbaConsider = 'fbaConsider',
  NoneCatalog = 'noneCatalog',
  NoneProfit = 'noneProfit',
  NoneStock = 'noneStock',
  Other = 'other',
  ScheduledDiscontinue = 'scheduledDiscontinue'
}

export type OpenCloseStoreFilter = {
  fromLastUpdate?: string | null | undefined;
  fromTargetDate?: string | null | undefined;
  storeAreaId?: string | number | null | undefined;
  toLastUpdate?: string | null | undefined;
  toTargetDate?: string | null | undefined;
};

export type RegisterAdminUserInput = {
  email: string;
  functions?: Array<string> | null | undefined;
  name: string;
};

export type RegisterAdminUsersInput = {
  serviceType: string;
  userGroupId: number;
  userRole?: string | null | undefined;
  users: Array<RegisterAdminUserInput>;
};

export type SearchDiscontinuedProductInput = {
  amazonCategoryId?: number | null | undefined;
  asins?: Array<string | null | undefined> | null | undefined;
  categoryIDs?: Array<number | null | undefined> | null | undefined;
  fromDate?: string | null | undefined;
  jans?: Array<string | null | undefined> | null | undefined;
};

export enum ShopType {
  Rakuten = 'rakuten',
  Yahoo = 'yahoo'
}

export enum StockFlag {
  Restricted = 'RESTRICTED',
  Skipped = 'SKIPPED',
  StaffNoStock = 'STAFF_NO_STOCK'
}

export type UpsertKeepaProductInput = {
  asin: string;
  boughtPastMonth: number;
  categoryNames?: Array<string> | null | undefined;
  keepaUpdatedAt?: string | null | undefined;
  lastKnownPrice?: number | null | undefined;
  lastKnownPriceAt?: string | null | undefined;
  latestPrice?: number | null | undefined;
};

export type UserPricetarProductInput = {
  asin: string;
  buyingPrice: number;
  condition: Condition;
  deliveryRoute: string;
  isPublic: boolean;
  orderDate: string;
  productName: string;
  salesCommission: number;
  sellingPrice: number;
  sku: string;
};

export type UserSedoristProductInput = {
  asin: string;
  buyingDate: string;
  buyingPrice: number;
  condition: Condition;
  deliveryRoute: string;
  isPublic: boolean;
  jan?: string | null | undefined;
  productName: string;
  sellingPrice: number;
  sku: string;
};

export enum UserSubRole {
  Iris = 'iris',
  ProductShare = 'productShare'
}

export type AdminUsersQueryVariables = Exact<{
  userGroupId?: number | null | undefined;
}>;


export type AdminUsersQuery = { adminUsers: Array<{ id: number, name: string | null, email: string, userRole: string, serviceType: string, functions: Array<string>, isDeleted: boolean, createdAt: string, updatedAt: string, userGroup: { name: string } }> };

export type RegisterAdminUsersMutationVariables = Exact<{
  input: RegisterAdminUsersInput;
}>;


export type RegisterAdminUsersMutation = { registerAdminUsers: { success: boolean, message: string | null, users: Array<{ userId: number, email: string, password: string }> } };

export type ResetAdminUserPasswordMutationVariables = Exact<{
  userId: number;
}>;


export type ResetAdminUserPasswordMutation = { resetAdminUserPassword: { success: boolean, message: string | null, userId: number, password: string } };

export type DeleteAdminUserMutationVariables = Exact<{
  userId: number;
}>;


export type DeleteAdminUserMutation = { deleteAdminUser: { success: boolean, message: string | null } };

export type UpdateAdminUserFunctionsMutationVariables = Exact<{
  userId: number;
  functions: Array<string> | string;
}>;


export type UpdateAdminUserFunctionsMutation = { updateAdminUserFunctions: { success: boolean, message: string | null, adminUser: { id: number, functions: Array<string> } } };

export type AeonProductsQueryVariables = Exact<{
  prefectures?: Array<string | null | undefined> | string | null | undefined;
}>;


export type AeonProductsQuery = { queueAeonProducts: Array<{ jan: string, createdAt: string } | null> | null, assertAeonProducts: { canRegisterNewItem: boolean } | null, aeonProducts: Array<{ id: string, productName: string, price: number, lastCheckedAt: string, createdAt: string, isDeleted: boolean, totalStockNum: number, stocks: Array<{ prefecture: string, storeName: string, hasStock: boolean, stockValue: string, note: string | null } | null> | null, product: { jan: string, amazonProducts: Array<{ name: string, asin: string, isMain: boolean, imageUrl: string | null, latestPrice: number, latestRanking: number, newSellerNum: number, oldSellerNum: number, salesBeginDate: string | null, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null, keepaProduct: { boughtPastMonth: number | null } | null }> }, userAeonProduct: { id: string, anotherPrice: number | null, user: { id: number, name: string | null } } | null } | null> | null };

export type RegisterQueueAeonMutationVariables = Exact<{
  jan: string;
}>;


export type RegisterQueueAeonMutation = { registerQueueAeonProduct: boolean };

export type UpdateUserAeonProductMutationVariables = Exact<{
  id: string | number;
  anotherPrice: number;
}>;


export type UpdateUserAeonProductMutation = { updateUserAeonProduct: boolean };

export type DeleteAeonProductMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteAeonProductMutation = { deleteAeonProduct: boolean };

export type UserAmazonTrackingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAmazonTrackingsQuery = { userAmazonTrackings: Array<{ id: number, probability: number | null, memo: string | null, createdAt: string, updatedAt: string, user: { id: number, name: string | null }, amazonProduct: { id: number, asin: string, name: string, imageUrl: string | null, isMain: boolean, latestPrice: number, latestRanking: number, newSellerNum: number, oldSellerNum: number, keepaProduct: { boughtPastMonth: number | null } | null } }> };

export type RegisterUserAmazonTrackingsMutationVariables = Exact<{
  inputs: Array<AmazonTrackingInput> | AmazonTrackingInput;
}>;


export type RegisterUserAmazonTrackingsMutation = { registerUserAmazonTrackings: { registeredCount: number, skippedAsins: Array<string> } };

export type UpsertUserAmazonTrackingMutationVariables = Exact<{
  asin: string;
  memo?: string | null | undefined;
  probability?: number | null | undefined;
}>;


export type UpsertUserAmazonTrackingMutation = { upsertUserAmazonTracking: boolean };

export type RemoveUserAmazonTrackingMutationVariables = Exact<{
  asin: string;
}>;


export type RemoveUserAmazonTrackingMutation = { removeUserAmazonTracking: boolean };

export type RegisterDiscontinuedCategoryMutationVariables = Exact<{
  name: string;
}>;


export type RegisterDiscontinuedCategoryMutation = { registerDiscontinuedCategory: boolean };

export type RegisterDiscontinuedJansMutationVariables = Exact<{
  jans: Array<string> | string;
  categoryId: number;
}>;


export type RegisterDiscontinuedJansMutation = { registerDiscontinuedJans: boolean };

export type UpsertDiscontinuedMemoMutationVariables = Exact<{
  id: string | number;
  memo: string;
}>;


export type UpsertDiscontinuedMemoMutation = { upsertDiscontinuedMemo: boolean };

export type DiscontinuedCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscontinuedCategoriesQuery = { discontinuedCategories: Array<{ id: string, name: string } | null> | null };

export type DeleteDiscontinuedProductMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteDiscontinuedProductMutation = { deleteDiscontinuedProduct: boolean };

export type DiscontinueProductsQueryVariables = Exact<{
  input?: SearchDiscontinuedProductInput | null | undefined;
}>;


export type DiscontinueProductsQuery = { discontinuedProducts: Array<{ id: string, memo: string | null, discontinuedAt: string, discontinuedCategories: Array<{ id: string, name: string, initialRegisteredAt: string }>, product: { id: string, jan: string, amazonProducts: Array<{ name: string, asin: string, isMain: boolean, imageUrl: string | null, latestRanking: number, latestPrice: number, newSellerNum: number, oldSellerNum: number, salesBeginDate: string | null, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null, topCategory: string | null }> } } | null> | null };

export type ProductImageFieldsFragment = { id: string, url: string, width: number, height: number, byteSize: number, position: number, createdAt: string };

export type DeleteProductImageMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteProductImageMutation = { deleteProductImage: boolean };

export type UpsertKeepaProductsMutationVariables = Exact<{
  input: Array<UpsertKeepaProductInput> | UpsertKeepaProductInput;
}>;


export type UpsertKeepaProductsMutation = { upsertKeepaProducts: { success: boolean, message: string | null, keepaProducts: Array<{ id: number, boughtPastMonth: number | null, amazonProduct: { asin: string, name: string } }> } };

export type KeepaProductsWithStockQueryVariables = Exact<{
  onlyMissingKeepa?: boolean | null | undefined;
}>;


export type KeepaProductsWithStockQuery = { keepaProductsWithStock: Array<{ asin: string, boughtPastMonth: number | null, storeImportedAt: string | null, keepaImportedAt: string | null }> };

export type MemberReportsQueryVariables = Exact<{
  days?: number | null | undefined;
}>;


export type MemberReportsQuery = { memberReports: Array<{ id: number, source: string, jan: string, price: number | null, storeName: string | null, memberName: string, comment: string | null, reportedAt: string, product: { jan: string, amazonProducts: Array<{ asin: string, isMain: boolean, name: string, imageUrl: string | null, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null, latestPrice: number, lastKnownPrice: { price: number, at: string } | null, keepaProduct: { boughtPastMonth: number | null, latestPrice: number | null, keepaUpdatedAt: string | null, lastKnownPrice: { price: number, at: string } | null } | null }> } | null }> };

export type DeleteMemberReportMutationVariables = Exact<{
  id: number;
}>;


export type DeleteMemberReportMutation = { deleteMemberReport: boolean };

export type OpenCloseStoresQueryVariables = Exact<{
  input?: OpenCloseStoreFilter | null | undefined;
}>;


export type OpenCloseStoresQuery = { openCloseStores: Array<{ id: string, type: string, targetDate: string, chainName: string, storeName: string, url: string | null, infoSource: string, lastUpdate: string, confirmor: string, note: string | null, createdAt: string, updatedAt: string, storeArea: { id: string, name: string } }>, storeAreas: Array<{ id: string, name: string }> | null };

export type YamadaProductsQueryVariables = Exact<{
  id?: string | number | null | undefined;
  registrationDate?: string | null | undefined;
}>;


export type YamadaProductsQuery = { yamadaProducts: Array<{ id: string, price: number, totalStocks: number, registrationDate: string, createdAt: string, stocks: Array<{ id: string, stockNum: number, createdAt: string, store: { id: string, code: string, name: string, area: { id: string, name: string } }, operation: { isPurchased: boolean, purchasedAt: string | null, purchasedQuantity: number | null, isNotFound: boolean, notFoundAt: string | null, memo: string | null, memoAddedAt: string | null, isDisplay: boolean, displaySetAt: string | null, isRestricted: boolean, restrictedAt: string | null, isSkipped: boolean, skippedAt: string | null, isStaffNoStock: boolean, staffNoStockAt: string | null, purchasedUser: { id: number, name: string | null } | null, notFoundUser: { id: number, name: string | null } | null, memoUser: { id: number, name: string | null } | null, displayUser: { id: number, name: string | null } | null, restrictedUser: { id: number, name: string | null } | null, skippedUser: { id: number, name: string | null } | null, staffNoStockUser: { id: number, name: string | null } | null } | null }>, product: { id: string, jan: string, amazonProducts: Array<{ id: number, name: string, asin: string, latestPrice: number, imageUrl: string | null, isMain: boolean, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null, lastKnownPrice: { price: number, at: string } | null, keepaProduct: { boughtPastMonth: number | null, latestPrice: number | null, keepaUpdatedAt: string | null, lastKnownPrice: { price: number, at: string } | null } | null }> } }> | null, storeAreas: Array<{ id: string, name: string, yamadaStores: Array<{ id: string, name: string }> }> | null };

export type UpsertYamadaProductMemoMutationVariables = Exact<{
  id: string | number;
  memo: string;
}>;


export type UpsertYamadaProductMemoMutation = { upsertYamadaProductMemo: boolean };

export type PurchaseYamadaStockMutationVariables = Exact<{
  id: string | number;
  quantity?: number | null | undefined;
}>;


export type PurchaseYamadaStockMutation = { purchaseYamadaStock: boolean };

export type PurchaseCancelYamadaStockMutationVariables = Exact<{
  id: string | number;
}>;


export type PurchaseCancelYamadaStockMutation = { purchaseCancelYamadaStock: boolean };

export type NotFoundYamadaStockMutationVariables = Exact<{
  id: string | number;
}>;


export type NotFoundYamadaStockMutation = { notFoundYamadaStock: boolean };

export type FoundYamadaStockMutationVariables = Exact<{
  id: string | number;
}>;


export type FoundYamadaStockMutation = { foundYamadaStock: boolean };

export type DisplayYamadaStockMutationVariables = Exact<{
  id: string | number;
}>;


export type DisplayYamadaStockMutation = { displayYamadaStock: boolean };

export type DisplayCancelYamadaStockMutationVariables = Exact<{
  id: string | number;
}>;


export type DisplayCancelYamadaStockMutation = { displayCancelYamadaStock: boolean };

export type SetYamadaStockFlagMutationVariables = Exact<{
  id: string | number;
  flag: StockFlag;
  on: boolean;
}>;


export type SetYamadaStockFlagMutation = { setYamadaStockFlag: boolean };

export type SetEdionStockFlagMutationVariables = Exact<{
  id: string | number;
  flag: StockFlag;
  on: boolean;
}>;


export type SetEdionStockFlagMutation = { setEdionStockFlag: boolean };

export type SetDonkiStockFlagMutationVariables = Exact<{
  id: string | number;
  flag: StockFlag;
  on: boolean;
}>;


export type SetDonkiStockFlagMutation = { setDonkiStockFlag: boolean };

export type EdionProductsQueryVariables = Exact<{
  id?: string | number | null | undefined;
  registrationDate?: string | null | undefined;
}>;


export type EdionProductsQuery = { edionProducts: Array<{ id: string, posPrice: number, discountPrice: number | null, totalStocks: number, registrationDate: string, disposalRank: string | null, createdAt: string, stocks: Array<{ id: string, stockNum: number, createdAt: string, store: { id: string, code: string, name: string, area: { id: string, name: string } }, operation: { isPurchased: boolean, purchasedAt: string | null, purchasedQuantity: number | null, isNotFound: boolean, notFoundAt: string | null, memo: string | null, memoAddedAt: string | null, isDisplay: boolean, displaySetAt: string | null, isRestricted: boolean, restrictedAt: string | null, isSkipped: boolean, skippedAt: string | null, isStaffNoStock: boolean, staffNoStockAt: string | null, purchasedUser: { id: number, name: string | null } | null, notFoundUser: { id: number, name: string | null } | null, memoUser: { id: number, name: string | null } | null, displayUser: { id: number, name: string | null } | null, restrictedUser: { id: number, name: string | null } | null, skippedUser: { id: number, name: string | null } | null, staffNoStockUser: { id: number, name: string | null } | null } | null }>, product: { id: string, jan: string, amazonProducts: Array<{ id: number, name: string, asin: string, latestPrice: number, imageUrl: string | null, isMain: boolean, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null, lastKnownPrice: { price: number, at: string } | null, keepaProduct: { boughtPastMonth: number | null, latestPrice: number | null, keepaUpdatedAt: string | null, lastKnownPrice: { price: number, at: string } | null } | null }> } }> | null, storeAreas: Array<{ id: string, name: string, edionStores: Array<{ id: string, name: string }> }> | null };

export type UpsertEdionProductMemoMutationVariables = Exact<{
  id: string | number;
  memo: string;
}>;


export type UpsertEdionProductMemoMutation = { upsertEdionProductMemo: boolean };

export type PurchaseEdionStockMutationVariables = Exact<{
  id: string | number;
  quantity?: number | null | undefined;
}>;


export type PurchaseEdionStockMutation = { purchaseEdionStock: boolean };

export type PurchaseCancelEdionStockMutationVariables = Exact<{
  id: string | number;
}>;


export type PurchaseCancelEdionStockMutation = { purchaseCancelEdionStock: boolean };

export type NotFoundEdionStockMutationVariables = Exact<{
  id: string | number;
}>;


export type NotFoundEdionStockMutation = { notFoundEdionStock: boolean };

export type FoundEdionStockMutationVariables = Exact<{
  id: string | number;
}>;


export type FoundEdionStockMutation = { foundEdionStock: boolean };

export type DisplayEdionStockMutationVariables = Exact<{
  id: string | number;
}>;


export type DisplayEdionStockMutation = { displayEdionStock: boolean };

export type DisplayCancelEdionStockMutationVariables = Exact<{
  id: string | number;
}>;


export type DisplayCancelEdionStockMutation = { displayCancelEdionStock: boolean };

export type DonkiProductsQueryVariables = Exact<{
  id?: string | number | null | undefined;
  registrationDate?: string | null | undefined;
}>;


export type DonkiProductsQuery = { donkiProducts: Array<{ id: string, totalStocks: number, registrationDate: string, stocks: Array<{ id: string, stockNum: number, price: number, createdAt: string, store: { id: string, name: string, area: { id: string, name: string } }, operation: { isPurchased: boolean, purchasedAt: string | null, purchasedQuantity: number | null, isNotFound: boolean, notFoundAt: string | null, memo: string | null, memoAddedAt: string | null, isDisplay: boolean, displaySetAt: string | null, isRestricted: boolean, restrictedAt: string | null, isSkipped: boolean, skippedAt: string | null, isStaffNoStock: boolean, staffNoStockAt: string | null, isConfirmed: boolean, confirmedSetAt: string | null, purchasedUser: { id: number, name: string | null } | null, notFoundUser: { id: number, name: string | null } | null, memoUser: { id: number, name: string | null } | null, displayUser: { id: number, name: string | null } | null, restrictedUser: { id: number, name: string | null } | null, skippedUser: { id: number, name: string | null } | null, staffNoStockUser: { id: number, name: string | null } | null, confirmedUser: { id: number, name: string | null } | null } | null }>, product: { id: string, jan: string, amazonProducts: Array<{ id: number, name: string, asin: string, latestPrice: number, imageUrl: string | null, isMain: boolean, keepaProduct: { boughtPastMonth: number | null } | null }> } }> | null, storeAreas: Array<{ id: string, name: string, donkiStores: Array<{ id: string, name: string }> }> | null };

export type UpsertDonkiProductMemoMutationVariables = Exact<{
  id: string | number;
  memo: string;
}>;


export type UpsertDonkiProductMemoMutation = { upsertDonkiProductMemo: boolean };

export type PurchaseDonkiStockMutationVariables = Exact<{
  id: string | number;
  quantity?: number | null | undefined;
}>;


export type PurchaseDonkiStockMutation = { purchaseDonkiStock: boolean };

export type PurchaseCancelDonkiStockMutationVariables = Exact<{
  id: string | number;
}>;


export type PurchaseCancelDonkiStockMutation = { purchaseCancelDonkiStock: boolean };

export type NotFoundDonkiStockMutationVariables = Exact<{
  id: string | number;
}>;


export type NotFoundDonkiStockMutation = { notFoundDonkiStock: boolean };

export type FoundDonkiStockMutationVariables = Exact<{
  id: string | number;
}>;


export type FoundDonkiStockMutation = { foundDonkiStock: boolean };

export type DisplayDonkiStockMutationVariables = Exact<{
  id: string | number;
}>;


export type DisplayDonkiStockMutation = { displayDonkiStock: boolean };

export type DisplayCancelDonkiStockMutationVariables = Exact<{
  id: string | number;
}>;


export type DisplayCancelDonkiStockMutation = { displayCancelDonkiStock: boolean };

export type ConfirmDonkiStockMutationVariables = Exact<{
  id: string | number;
}>;


export type ConfirmDonkiStockMutation = { confirmDonkiStock: boolean };

export type ConfirmCancelDonkiStockMutationVariables = Exact<{
  id: string | number;
}>;


export type ConfirmCancelDonkiStockMutation = { confirmCancelDonkiStock: boolean };

export type LoggingQueryVariables = Exact<{
  name: string;
  log: string;
}>;


export type LoggingQuery = { logging: boolean };

export type RegisterTokenValidateQueryVariables = Exact<{
  token: string;
}>;


export type RegisterTokenValidateQuery = { registerTokenValidate: { email: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { id: number, name: string | null, userRole: string, telegramToken: string | null, isStoreManager: boolean, hasRefreshToken: boolean, functions: Array<string | null> | null, userSubRoles: Array<UserSubRole | null>, userGroup: { name: string } } };

export type MeWithTelegramQueryVariables = Exact<{ [key: string]: never; }>;


export type MeWithTelegramQuery = { me: { id: number, userRole: string, telegramToken: string | null, isStoreManager: boolean, hasRefreshToken: boolean, userSubRoles: Array<UserSubRole | null>, userTelegram: { id: number, firstName: string, lastName: string, chatID: string } | null } };

export type UsersQueryVariables = Exact<{
  serviceType: string;
}>;


export type UsersQuery = { users: Array<{ id: number, name: string | null, orderInGroup: number | null } | null> | null };

export type ShopQueryVariables = Exact<{
  shopType: ShopType;
  shopCode: string;
}>;


export type ShopQuery = { shop: { shopCode: string, shopName: string, shopUrl: string, latestStartedAt: string | null, latestEndAt: string | null, latestMinPrice: number | null, latestMaxPrice: number | null, totalProductNum: number, updatedProductNum: number, totalAmazonNum: number, updatedAmazonNum: number, isDoing: boolean } };

export type UserUpdateShopQueryVariables = Exact<{ [key: string]: never; }>;


export type UserUpdateShopQuery = { userUpdateShop: { shopType: string, shopCode: string } | null };

export type ProductDetailsQueryVariables = Exact<{
  shopType: ShopType;
  shopCode: string;
  minPrice: number;
  maxPrice: number;
  minGross?: number | null | undefined;
  minProfitRate?: number | null | undefined;
  hasNewProduct?: boolean | null | undefined;
  minRanking?: number | null | undefined;
}>;


export type ProductDetailsQuery = { productDetails: Array<{ jan: string, modelNumber: string | null, referencePrice: number | null, amazonProducts: Array<{ name: string, asin: string, isMain: boolean, latestRanking: number, latestPrice: number, newSellerNum: number, oldSellerNum: number, salesBeginDate: string | null, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null }>, rakutenProducts: Array<{ productCode: string, name: string, price: number, url: string, hasStock: boolean }> }> };

export type UserSedoristProductsQueryVariables = Exact<{
  keyword?: string | null | undefined;
  fromDate?: string | null | undefined;
  toDate?: string | null | undefined;
  filterUserProduct: FilterUserProduct;
  filterOtherSetting?: FilterOtherSetting | null | undefined;
  buyingStoreIds?: Array<number | null | undefined> | number | null | undefined;
  buyingStoreTypeId?: number | null | undefined;
  filterUserIds?: Array<number | null | undefined> | number | null | undefined;
  amazonCategoryId?: number | null | undefined;
}>;


export type UserSedoristProductsQuery = { userSedoristProducts: Array<{ id: number, sku: string, productName: string, buyingPrice: number, sellingPrice: number, buyingDate: string, condition: Condition, deliveryRoute: string, memo: string | null, ipMemo: string | null, isPriceDownInCacheRegister: boolean, isSleeped: boolean, isPriceNegotiation: boolean, topCategory: string | null, isPublic: boolean, createdAt: string, user: { email: string, name: string | null }, amazonProduct: { asin: string, isMain: boolean, imageUrl: string | null, salesCommission: number | null, salesBeginDate: string | null, categoryFee: number | null, fbaShippingFee: number | null, latestPrice: number, lastKnownPrice: { price: number, at: string } | null, keepaProduct: { boughtPastMonth: number | null, latestPrice: number | null, keepaUpdatedAt: string | null, lastKnownPrice: { price: number, at: string } | null } | null }, product: { jan: string } | null, buyingStore: { id: number, name: string, buyingStoreType: { id: number, name: string } } | null, sheetData: { Yamada: string | null, Edion: string | null, Donki: string | null }, images: Array<{ id: string, url: string, width: number, height: number, byteSize: number, position: number, createdAt: string }> }> };

export type UserPricetarProductsQueryVariables = Exact<{
  keyword?: string | null | undefined;
  fromDate?: string | null | undefined;
  toDate?: string | null | undefined;
  filterUserProduct: FilterUserProduct;
  filterOtherSetting?: FilterOtherSetting | null | undefined;
  buyingStoreIds?: Array<number | null | undefined> | number | null | undefined;
  buyingStoreTypeId?: number | null | undefined;
  filterUserIds?: Array<number | null | undefined> | number | null | undefined;
  amazonCategoryId?: number | null | undefined;
}>;


export type UserPricetarProductsQuery = { userPricetarProducts: Array<{ id: number, sku: string, productName: string, buyingPrice: number, sellingPrice: number, orderDate: string, deliveryRoute: string, memo: string | null, ipMemo: string | null, isPriceDownInCacheRegister: boolean, isSleeped: boolean, isPriceNegotiation: boolean, salesCommission: number, condition: Condition, topCategory: string | null, isPublic: boolean, createdAt: string, user: { email: string, name: string | null }, amazonProduct: { asin: string, isMain: boolean, imageUrl: string | null, salesCommission: number | null, salesBeginDate: string | null, categoryFee: number | null, fbaShippingFee: number | null }, product: { jan: string } | null, buyingStore: { id: number, name: string, buyingStoreType: { id: number, name: string } } | null, sheetData: { Yamada: string | null, Edion: string | null, Donki: string | null }, images: Array<{ id: string, url: string, width: number, height: number, byteSize: number, position: number, createdAt: string }> }> };

export type IrisProductQueryVariables = Exact<{ [key: string]: never; }>;


export type IrisProductQuery = { irisProduct: Array<{ id: number, irisProductCode: string, name: string, modelNumber: string | null, color: string | null, referencePrice: number | null, lvonPrice: number, quantity: number | null, orderLevel: string | null, outerCaseSizeW: number | null, outerCaseSizeD: number | null, outerCaseSizeH: number | null, kilogram: number | null, discontinuedSchedule: string | null, note: string | null, memo: string | null, priceRevision: string | null, lastImportedAt: string, useFba: boolean, updatedAt: string, createdAt: string, irisSalesResults: Array<{ id: number, salesMonth: string, salesQuantity: number } | null> | null, product: { jan: string, amazonProducts: Array<{ asin: string, isMain: boolean, latestPrice: number, latestRanking: number, newSellerNum: number, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null }> }, latestHistory: { lvonPrice: number } | null } | null> | null };

export type BuyingStoresQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyingStoresQuery = { buyingStores: Array<{ id: number, name: string, buyingStoreType: { id: number, name: string } } | null> | null };

export type BuyingStoreTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyingStoreTypesQuery = { buyingStoreTypes: Array<{ id: number, name: string, buyingStores: Array<{ id: number, name: string } | null> | null } | null> | null };

export type AmazonCategoriesQueryVariables = Exact<{
  isTop?: boolean | null | undefined;
}>;


export type AmazonCategoriesQuery = { amazonCategories: Array<{ id: number, name: string, isTop: boolean } | null> | null };

export type BiccameraProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type BiccameraProductsQuery = { queueBiccameraProducts: Array<{ biccameraItemId: string, createdAt: string } | null> | null, assertBiccameraProducts: { canRegisterNewItem: boolean } | null, biccameraProducts: Array<{ id: string, productName: string, price: number, biccameraItemId: string, lastCheckedAt: string, createdAt: string, isDeleted: boolean, totalStockNum: number, stocks: Array<{ areaName: string, prefecture: string, storeName: string, hasStock: boolean, stockMark: string | null, note: string | null } | null> | null, product: { jan: string, amazonProducts: Array<{ name: string, asin: string, isMain: boolean, imageUrl: string | null, latestPrice: number, latestRanking: number, newSellerNum: number, oldSellerNum: number, salesBeginDate: string | null, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null, keepaProduct: { boughtPastMonth: number | null } | null }> }, userBiccameraProduct: { id: string, anotherPrice: number | null, user: { id: number, name: string | null } } | null } | null> | null };

export type KojimaProductsQueryVariables = Exact<{
  areas?: Array<string | null | undefined> | string | null | undefined;
  prefectures?: Array<string | null | undefined> | string | null | undefined;
  stores?: Array<string | null | undefined> | string | null | undefined;
}>;


export type KojimaProductsQuery = { queueKojimaProducts: Array<{ jan: string, createdAt: string } | null> | null, assertKojimaProducts: { canRegisterNewItem: boolean } | null, kojimaProducts: Array<{ id: string, productName: string, price: number, lastCheckedAt: string, createdAt: string, isDeleted: boolean, totalStockNum: number, stocks: Array<{ areaId: string, areaName: string, prefecture: string, storeName: string, hasStock: boolean, stockValue: string, note: string | null } | null> | null, product: { jan: string, amazonProducts: Array<{ name: string, asin: string, isMain: boolean, imageUrl: string | null, latestPrice: number, latestRanking: number, newSellerNum: number, oldSellerNum: number, salesBeginDate: string | null, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null, keepaProduct: { boughtPastMonth: number | null } | null }> }, userKojimaProduct: { id: string, anotherPrice: number | null, user: { id: number, name: string | null } } | null } | null> | null };

export type UserAmazonNoticeProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAmazonNoticeProductsQuery = { userAmazonNoticeProducts: Array<{ amazonProduct: { name: string, asin: string, isMain: boolean, imageUrl: string | null, latestRanking: number, latestPrice: number, newSellerNum: number, oldSellerNum: number, salesBeginDate: string | null, salesCommission: number | null, categoryFee: number | null, fbaShippingFee: number | null, topCategory: string | null, keepaProduct: { boughtPastMonth: number | null } | null }, product: { jan: string }, amazonNotifications: Array<{ id: number, notifiedAt: string, notificationType: string, detail: string | null, createdAt: string }>, userAmazonNotification: { id: number, memo: string | null, createdAt: string, user: { id: number, name: string | null } } | null }> };

export type SigninMutationVariables = Exact<{
  email: string;
  password: string;
  serviceType: string;
}>;


export type SigninMutation = { signin: { token: string } };

export type RegisterUserMutationVariables = Exact<{
  token: string;
  salt: string;
  password: string;
}>;


export type RegisterUserMutation = { registerUser: { token: string } };

export type SignoutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignoutMutation = { signout: boolean | null };

export type RefreshMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshMutation = { refresh: boolean | null };

export type UpdateShopProductsMutationVariables = Exact<{
  shopType: ShopType;
  shopCode: string;
  minPrice: number;
  maxPrice: number;
  minGross?: number | null | undefined;
  minProfitRate?: number | null | undefined;
  hasNewProduct?: boolean | null | undefined;
  minRanking?: number | null | undefined;
}>;


export type UpdateShopProductsMutation = { updateShopProducts: { shopName: string, shopUrl: string, latestStartedAt: string | null, latestEndAt: string | null, totalProductNum: number } };

export type RegisterUserSedoristProductsMutationVariables = Exact<{
  userSedoristInputs?: Array<UserSedoristProductInput> | UserSedoristProductInput | null | undefined;
}>;


export type RegisterUserSedoristProductsMutation = { registerUserSedoristProducts: boolean | null };

export type RegisterUserPricetarProductsMutationVariables = Exact<{
  userPricetarInputs?: Array<UserPricetarProductInput> | UserPricetarProductInput | null | undefined;
}>;


export type RegisterUserPricetarProductsMutation = { registerUserPricetarProducts: boolean | null };

export type DeleteUserPricetarProductsMutationVariables = Exact<{
  id: number;
}>;


export type DeleteUserPricetarProductsMutation = { deleteUserPricetarProducts: boolean | null };

export type DeleteUserSedoristProductsMutationVariables = Exact<{
  id: number;
}>;


export type DeleteUserSedoristProductsMutation = { deleteUserSedoristProducts: boolean | null };

export type RegisterBuyingStoreMutationVariables = Exact<{
  name: string;
  typeId: number;
}>;


export type RegisterBuyingStoreMutation = { registerBuyingStore: number };

export type RegisterBuyingStoreTypeMutationVariables = Exact<{
  name: string;
}>;


export type RegisterBuyingStoreTypeMutation = { registerBuyingStoreType: number };

export type UpdateUserSedoristProductMutationVariables = Exact<{
  id: number;
  storeId?: number | null | undefined;
  memo?: string | null | undefined;
  ipMemo?: string | null | undefined;
  isPriceDownInCacheRegister?: boolean | null | undefined;
  isPriceNegotiation?: boolean | null | undefined;
  isSleeped?: boolean | null | undefined;
  isPublic?: boolean | null | undefined;
}>;


export type UpdateUserSedoristProductMutation = { updateUserSedoristProducts: boolean };

export type UpdateUserPricetarProductMutationVariables = Exact<{
  id: number;
  storeId?: number | null | undefined;
  memo?: string | null | undefined;
  ipMemo?: string | null | undefined;
  isPriceDownInCacheRegister?: boolean | null | undefined;
  isPriceNegotiation?: boolean | null | undefined;
  isSleeped?: boolean | null | undefined;
  isPublic?: boolean | null | undefined;
}>;


export type UpdateUserPricetarProductMutation = { updateUserPricetarProducts: boolean };

export type DeleteBuyingStoreMutationVariables = Exact<{
  id: number;
}>;


export type DeleteBuyingStoreMutation = { deleteBuyingStore: boolean };

export type DeleteBuyingStoreTypeMutationVariables = Exact<{
  id: number;
}>;


export type DeleteBuyingStoreTypeMutation = { deleteBuyingStoreType: boolean };

export type UpdateBuyingStoreOrderMutationVariables = Exact<{
  typeId: number;
  ids?: Array<number> | number | null | undefined;
}>;


export type UpdateBuyingStoreOrderMutation = { updateBuyingStoreOrder: boolean };

export type UpdateBuyingStoreTypeOrderMutationVariables = Exact<{
  ids?: Array<number> | number | null | undefined;
}>;


export type UpdateBuyingStoreTypeOrderMutation = { updateBuyingStoreTypeOrder: boolean };

export type UpdateOrderLevelMutationVariables = Exact<{
  id: number;
  orderLevel: IrisOrderLevel;
}>;


export type UpdateOrderLevelMutation = { updateIrisOrderLevel: boolean };

export type UpdateIrisMemoMutationVariables = Exact<{
  id: number;
  memo: string;
}>;


export type UpdateIrisMemoMutation = { updateIrisMemo: boolean };

export type RegsiterQueueBiccameraMutationVariables = Exact<{
  itemId: string;
}>;


export type RegsiterQueueBiccameraMutation = { registerQueueBiccameraProduct: boolean };

export type UpdateUserBiccameraProductMutationVariables = Exact<{
  id: string | number;
  anotherPrice: number;
}>;


export type UpdateUserBiccameraProductMutation = { updateUserBiccameraProduct: boolean };

export type RegsiterQueueKojimaMutationVariables = Exact<{
  jan: string;
}>;


export type RegsiterQueueKojimaMutation = { registerQueueKojimaProduct: boolean };

export type UpdateUserKojimaProductMutationVariables = Exact<{
  id: string | number;
  anotherPrice: number;
}>;


export type UpdateUserKojimaProductMutation = { updateUserKojimaProduct: boolean };

export type UpdateIrisFbaMutationVariables = Exact<{
  id: number;
  useFba: boolean;
}>;


export type UpdateIrisFbaMutation = { updateIrisFba: boolean };

export type ExchangeRefreshTokenMutationVariables = Exact<{
  sellingPartnerID: string;
  spapiOauthCode: string;
  state: string;
}>;


export type ExchangeRefreshTokenMutation = { exchangeRefreshToken: boolean };

export type DeleteKojimaProductMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteKojimaProductMutation = { deleteKojimaProduct: boolean };

export type DeleteBiccameraProductMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteBiccameraProductMutation = { deleteBiccameraProduct: boolean };

export type UserAmazonNotificationsQueryVariables = Exact<{
  createdAtFrom?: string | null | undefined;
}>;


export type UserAmazonNotificationsQuery = { userAmazonNotifications: Array<{ id: number, memo: string | null, createdAt: string, user: { id: number, name: string | null }, amazonProduct: { id: number, asin: string, name: string, imageUrl: string | null, isMain: boolean, latestPrice: number, latestRanking: number, newSellerNum: number, oldSellerNum: number, keepaProduct: { boughtPastMonth: number | null } | null } }> };

export type RegisterUserAmazonNotificationMutationVariables = Exact<{
  asins: Array<string> | string;
}>;


export type RegisterUserAmazonNotificationMutation = { registerUserAmazonNotification: boolean };

export type UpsertUserAmazonNotificationMutationVariables = Exact<{
  asin: string;
  memo?: string | null | undefined;
}>;


export type UpsertUserAmazonNotificationMutation = { upsertUserAmazonNotification: boolean };

export type RemoveUserAmazonNotificationMutationVariables = Exact<{
  asin: string;
}>;


export type RemoveUserAmazonNotificationMutation = { removeUserAmazonNotification: boolean };

export type CheckSpapiTokenValidQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckSpapiTokenValidQuery = { checkSpapiTokenValid: { valid: boolean, message: string | null } };

export type AmazonPriceTracksQueryVariables = Exact<{ [key: string]: never; }>;


export type AmazonPriceTracksQuery = { amazonPriceTrack: Array<{ id: number, thresholdPrice: number, amazonProduct: { asin: string, name: string, imageUrl: string | null, latestPrice: number, latestRanking: number, newSellerNum: number, oldSellerNum: number } } | null> | null };

export type UpsertAmazonPriceTrackMutationVariables = Exact<{
  asin: string;
  thresholdPrice: number;
}>;


export type UpsertAmazonPriceTrackMutation = { upsertAmazonPriceTrack: boolean };

export type DeleteAmazonPriceTrackMutationVariables = Exact<{
  id: number;
}>;


export type DeleteAmazonPriceTrackMutation = { deleteAmazonPriceTrack: boolean };

export type DeleteAmazonProductsMutationVariables = Exact<{
  asins: Array<string> | string;
}>;


export type DeleteAmazonProductsMutation = { deleteAmazonProducts: boolean };

export const ProductImageFieldsFragmentDoc = gql`
    fragment ProductImageFields on ProductImage {
  id
  url
  width
  height
  byteSize
  position
  createdAt
}
    `;
export const AdminUsersDocument = gql`
    query adminUsers($userGroupId: Int) {
  adminUsers(userGroupId: $userGroupId) {
    id
    name
    email
    userRole
    serviceType
    functions
    isDeleted
    createdAt
    updatedAt
    userGroup {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdminUsersGQL extends Apollo.Query<AdminUsersQuery, AdminUsersQueryVariables> {
    document = AdminUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterAdminUsersDocument = gql`
    mutation registerAdminUsers($input: RegisterAdminUsersInput!) {
  registerAdminUsers(input: $input) {
    success
    message
    users {
      userId
      email
      password
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterAdminUsersGQL extends Apollo.Mutation<RegisterAdminUsersMutation, RegisterAdminUsersMutationVariables> {
    document = RegisterAdminUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetAdminUserPasswordDocument = gql`
    mutation resetAdminUserPassword($userId: Int!) {
  resetAdminUserPassword(userId: $userId) {
    success
    message
    userId
    password
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetAdminUserPasswordGQL extends Apollo.Mutation<ResetAdminUserPasswordMutation, ResetAdminUserPasswordMutationVariables> {
    document = ResetAdminUserPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAdminUserDocument = gql`
    mutation deleteAdminUser($userId: Int!) {
  deleteAdminUser(userId: $userId) {
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAdminUserGQL extends Apollo.Mutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables> {
    document = DeleteAdminUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAdminUserFunctionsDocument = gql`
    mutation updateAdminUserFunctions($userId: Int!, $functions: [String!]!) {
  updateAdminUserFunctions(userId: $userId, functions: $functions) {
    success
    message
    adminUser {
      id
      functions
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAdminUserFunctionsGQL extends Apollo.Mutation<UpdateAdminUserFunctionsMutation, UpdateAdminUserFunctionsMutationVariables> {
    document = UpdateAdminUserFunctionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AeonProductsDocument = gql`
    query aeonProducts($prefectures: [String]) {
  queueAeonProducts {
    jan
    createdAt
  }
  assertAeonProducts {
    canRegisterNewItem
  }
  aeonProducts(prefectures: $prefectures) {
    id
    productName
    price
    lastCheckedAt
    createdAt
    isDeleted
    totalStockNum
    stocks {
      prefecture
      storeName
      hasStock
      stockValue
      note
    }
    product {
      jan
      amazonProducts {
        name
        asin
        isMain
        imageUrl
        latestPrice
        latestRanking
        newSellerNum
        oldSellerNum
        salesBeginDate
        salesCommission
        categoryFee
        fbaShippingFee
        keepaProduct {
          boughtPastMonth
        }
      }
    }
    userAeonProduct {
      id
      anotherPrice
      user {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AeonProductsGQL extends Apollo.Query<AeonProductsQuery, AeonProductsQueryVariables> {
    document = AeonProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterQueueAeonDocument = gql`
    mutation registerQueueAeon($jan: String!) {
  registerQueueAeonProduct(jan: $jan)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterQueueAeonGQL extends Apollo.Mutation<RegisterQueueAeonMutation, RegisterQueueAeonMutationVariables> {
    document = RegisterQueueAeonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserAeonProductDocument = gql`
    mutation updateUserAeonProduct($id: ID!, $anotherPrice: Int!) {
  updateUserAeonProduct(id: $id, anotherPrice: $anotherPrice)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserAeonProductGQL extends Apollo.Mutation<UpdateUserAeonProductMutation, UpdateUserAeonProductMutationVariables> {
    document = UpdateUserAeonProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAeonProductDocument = gql`
    mutation deleteAeonProduct($id: ID!) {
  deleteAeonProduct(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAeonProductGQL extends Apollo.Mutation<DeleteAeonProductMutation, DeleteAeonProductMutationVariables> {
    document = DeleteAeonProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserAmazonTrackingsDocument = gql`
    query userAmazonTrackings {
  userAmazonTrackings {
    id
    probability
    memo
    createdAt
    updatedAt
    user {
      id
      name
    }
    amazonProduct {
      id
      asin
      name
      imageUrl
      isMain
      latestPrice
      latestRanking
      newSellerNum
      oldSellerNum
      keepaProduct {
        boughtPastMonth
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserAmazonTrackingsGQL extends Apollo.Query<UserAmazonTrackingsQuery, UserAmazonTrackingsQueryVariables> {
    document = UserAmazonTrackingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterUserAmazonTrackingsDocument = gql`
    mutation registerUserAmazonTrackings($inputs: [AmazonTrackingInput!]!) {
  registerUserAmazonTrackings(inputs: $inputs) {
    registeredCount
    skippedAsins
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterUserAmazonTrackingsGQL extends Apollo.Mutation<RegisterUserAmazonTrackingsMutation, RegisterUserAmazonTrackingsMutationVariables> {
    document = RegisterUserAmazonTrackingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertUserAmazonTrackingDocument = gql`
    mutation upsertUserAmazonTracking($asin: String!, $memo: String, $probability: Int) {
  upsertUserAmazonTracking(asin: $asin, memo: $memo, probability: $probability)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertUserAmazonTrackingGQL extends Apollo.Mutation<UpsertUserAmazonTrackingMutation, UpsertUserAmazonTrackingMutationVariables> {
    document = UpsertUserAmazonTrackingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserAmazonTrackingDocument = gql`
    mutation removeUserAmazonTracking($asin: String!) {
  removeUserAmazonTracking(asin: $asin)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserAmazonTrackingGQL extends Apollo.Mutation<RemoveUserAmazonTrackingMutation, RemoveUserAmazonTrackingMutationVariables> {
    document = RemoveUserAmazonTrackingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterDiscontinuedCategoryDocument = gql`
    mutation RegisterDiscontinuedCategory($name: String!) {
  registerDiscontinuedCategory(name: $name)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterDiscontinuedCategoryGQL extends Apollo.Mutation<RegisterDiscontinuedCategoryMutation, RegisterDiscontinuedCategoryMutationVariables> {
    document = RegisterDiscontinuedCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterDiscontinuedJansDocument = gql`
    mutation RegisterDiscontinuedJans($jans: [String!]!, $categoryId: Int!) {
  registerDiscontinuedJans(jans: $jans, discontinuedCategoryId: $categoryId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterDiscontinuedJansGQL extends Apollo.Mutation<RegisterDiscontinuedJansMutation, RegisterDiscontinuedJansMutationVariables> {
    document = RegisterDiscontinuedJansDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertDiscontinuedMemoDocument = gql`
    mutation UpsertDiscontinuedMemo($id: ID!, $memo: String!) {
  upsertDiscontinuedMemo(id: $id, memo: $memo)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertDiscontinuedMemoGQL extends Apollo.Mutation<UpsertDiscontinuedMemoMutation, UpsertDiscontinuedMemoMutationVariables> {
    document = UpsertDiscontinuedMemoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DiscontinuedCategoriesDocument = gql`
    query DiscontinuedCategories {
  discontinuedCategories {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DiscontinuedCategoriesGQL extends Apollo.Query<DiscontinuedCategoriesQuery, DiscontinuedCategoriesQueryVariables> {
    document = DiscontinuedCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDiscontinuedProductDocument = gql`
    mutation DeleteDiscontinuedProduct($id: ID!) {
  deleteDiscontinuedProduct(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDiscontinuedProductGQL extends Apollo.Mutation<DeleteDiscontinuedProductMutation, DeleteDiscontinuedProductMutationVariables> {
    document = DeleteDiscontinuedProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DiscontinueProductsDocument = gql`
    query DiscontinueProducts($input: SearchDiscontinuedProductInput) {
  discontinuedProducts(input: $input) {
    id
    memo
    discontinuedAt
    discontinuedCategories {
      id
      name
      initialRegisteredAt
    }
    product {
      id
      jan
      amazonProducts {
        name
        asin
        isMain
        imageUrl
        latestRanking
        latestPrice
        newSellerNum
        oldSellerNum
        salesBeginDate
        salesCommission
        categoryFee
        fbaShippingFee
        topCategory
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DiscontinueProductsGQL extends Apollo.Query<DiscontinueProductsQuery, DiscontinueProductsQueryVariables> {
    document = DiscontinueProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProductImageDocument = gql`
    mutation deleteProductImage($id: ID!) {
  deleteProductImage(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProductImageGQL extends Apollo.Mutation<DeleteProductImageMutation, DeleteProductImageMutationVariables> {
    document = DeleteProductImageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertKeepaProductsDocument = gql`
    mutation upsertKeepaProducts($input: [UpsertKeepaProductInput!]!) {
  upsertKeepaProducts(input: $input) {
    success
    message
    keepaProducts {
      id
      boughtPastMonth
      amazonProduct {
        asin
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertKeepaProductsGQL extends Apollo.Mutation<UpsertKeepaProductsMutation, UpsertKeepaProductsMutationVariables> {
    document = UpsertKeepaProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const KeepaProductsWithStockDocument = gql`
    query keepaProductsWithStock($onlyMissingKeepa: Boolean) {
  keepaProductsWithStock(onlyMissingKeepa: $onlyMissingKeepa) {
    asin
    boughtPastMonth
    storeImportedAt
    keepaImportedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class KeepaProductsWithStockGQL extends Apollo.Query<KeepaProductsWithStockQuery, KeepaProductsWithStockQueryVariables> {
    document = KeepaProductsWithStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MemberReportsDocument = gql`
    query memberReports($days: Int) {
  memberReports(days: $days) {
    id
    source
    jan
    price
    storeName
    memberName
    comment
    reportedAt
    product {
      jan
      amazonProducts {
        asin
        isMain
        name
        imageUrl
        salesCommission
        categoryFee
        fbaShippingFee
        latestPrice
        lastKnownPrice {
          price
          at
        }
        keepaProduct {
          boughtPastMonth
          latestPrice
          lastKnownPrice {
            price
            at
          }
          keepaUpdatedAt
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MemberReportsGQL extends Apollo.Query<MemberReportsQuery, MemberReportsQueryVariables> {
    document = MemberReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMemberReportDocument = gql`
    mutation deleteMemberReport($id: Int!) {
  deleteMemberReport(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMemberReportGQL extends Apollo.Mutation<DeleteMemberReportMutation, DeleteMemberReportMutationVariables> {
    document = DeleteMemberReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OpenCloseStoresDocument = gql`
    query OpenCloseStores($input: OpenCloseStoreFilter) {
  openCloseStores(filter: $input) {
    id
    type
    targetDate
    storeArea {
      id
      name
    }
    chainName
    storeName
    url
    infoSource
    lastUpdate
    confirmor
    note
    createdAt
    updatedAt
  }
  storeAreas {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OpenCloseStoresGQL extends Apollo.Query<OpenCloseStoresQuery, OpenCloseStoresQueryVariables> {
    document = OpenCloseStoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const YamadaProductsDocument = gql`
    query YamadaProducts($id: ID, $registrationDate: String) {
  yamadaProducts(id: $id, registrationDate: $registrationDate) {
    id
    price
    totalStocks
    registrationDate
    createdAt
    stocks {
      id
      store {
        id
        code
        name
        area {
          id
          name
        }
      }
      stockNum
      createdAt
      operation {
        isPurchased
        purchasedAt
        purchasedUser {
          id
          name
        }
        purchasedQuantity
        isNotFound
        notFoundAt
        notFoundUser {
          id
          name
        }
        memo
        memoAddedAt
        memoUser {
          id
          name
        }
        isDisplay
        displaySetAt
        displayUser {
          id
          name
        }
        isRestricted
        restrictedAt
        restrictedUser {
          id
          name
        }
        isSkipped
        skippedAt
        skippedUser {
          id
          name
        }
        isStaffNoStock
        staffNoStockAt
        staffNoStockUser {
          id
          name
        }
      }
    }
    product {
      id
      jan
      amazonProducts {
        id
        name
        asin
        latestPrice
        imageUrl
        isMain
        salesCommission
        categoryFee
        fbaShippingFee
        lastKnownPrice {
          price
          at
        }
        keepaProduct {
          boughtPastMonth
          latestPrice
          lastKnownPrice {
            price
            at
          }
          keepaUpdatedAt
        }
      }
    }
  }
  storeAreas {
    id
    name
    yamadaStores {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class YamadaProductsGQL extends Apollo.Query<YamadaProductsQuery, YamadaProductsQueryVariables> {
    document = YamadaProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertYamadaProductMemoDocument = gql`
    mutation UpsertYamadaProductMemo($id: ID!, $memo: String!) {
  upsertYamadaProductMemo(id: $id, memo: $memo)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertYamadaProductMemoGQL extends Apollo.Mutation<UpsertYamadaProductMemoMutation, UpsertYamadaProductMemoMutationVariables> {
    document = UpsertYamadaProductMemoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PurchaseYamadaStockDocument = gql`
    mutation PurchaseYamadaStock($id: ID!, $quantity: Int) {
  purchaseYamadaStock(id: $id, quantity: $quantity)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PurchaseYamadaStockGQL extends Apollo.Mutation<PurchaseYamadaStockMutation, PurchaseYamadaStockMutationVariables> {
    document = PurchaseYamadaStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PurchaseCancelYamadaStockDocument = gql`
    mutation PurchaseCancelYamadaStock($id: ID!) {
  purchaseCancelYamadaStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PurchaseCancelYamadaStockGQL extends Apollo.Mutation<PurchaseCancelYamadaStockMutation, PurchaseCancelYamadaStockMutationVariables> {
    document = PurchaseCancelYamadaStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotFoundYamadaStockDocument = gql`
    mutation NotFoundYamadaStock($id: ID!) {
  notFoundYamadaStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotFoundYamadaStockGQL extends Apollo.Mutation<NotFoundYamadaStockMutation, NotFoundYamadaStockMutationVariables> {
    document = NotFoundYamadaStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoundYamadaStockDocument = gql`
    mutation FoundYamadaStock($id: ID!) {
  foundYamadaStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoundYamadaStockGQL extends Apollo.Mutation<FoundYamadaStockMutation, FoundYamadaStockMutationVariables> {
    document = FoundYamadaStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisplayYamadaStockDocument = gql`
    mutation DisplayYamadaStock($id: ID!) {
  displayYamadaStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisplayYamadaStockGQL extends Apollo.Mutation<DisplayYamadaStockMutation, DisplayYamadaStockMutationVariables> {
    document = DisplayYamadaStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisplayCancelYamadaStockDocument = gql`
    mutation DisplayCancelYamadaStock($id: ID!) {
  displayCancelYamadaStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisplayCancelYamadaStockGQL extends Apollo.Mutation<DisplayCancelYamadaStockMutation, DisplayCancelYamadaStockMutationVariables> {
    document = DisplayCancelYamadaStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetYamadaStockFlagDocument = gql`
    mutation SetYamadaStockFlag($id: ID!, $flag: StockFlag!, $on: Boolean!) {
  setYamadaStockFlag(id: $id, flag: $flag, on: $on)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetYamadaStockFlagGQL extends Apollo.Mutation<SetYamadaStockFlagMutation, SetYamadaStockFlagMutationVariables> {
    document = SetYamadaStockFlagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetEdionStockFlagDocument = gql`
    mutation SetEdionStockFlag($id: ID!, $flag: StockFlag!, $on: Boolean!) {
  setEdionStockFlag(id: $id, flag: $flag, on: $on)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetEdionStockFlagGQL extends Apollo.Mutation<SetEdionStockFlagMutation, SetEdionStockFlagMutationVariables> {
    document = SetEdionStockFlagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetDonkiStockFlagDocument = gql`
    mutation SetDonkiStockFlag($id: ID!, $flag: StockFlag!, $on: Boolean!) {
  setDonkiStockFlag(id: $id, flag: $flag, on: $on)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDonkiStockFlagGQL extends Apollo.Mutation<SetDonkiStockFlagMutation, SetDonkiStockFlagMutationVariables> {
    document = SetDonkiStockFlagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EdionProductsDocument = gql`
    query EdionProducts($id: ID, $registrationDate: String) {
  edionProducts(id: $id, registrationDate: $registrationDate) {
    id
    posPrice
    discountPrice
    totalStocks
    registrationDate
    disposalRank
    createdAt
    stocks {
      id
      store {
        id
        code
        name
        area {
          id
          name
        }
      }
      stockNum
      createdAt
      operation {
        isPurchased
        purchasedAt
        purchasedUser {
          id
          name
        }
        purchasedQuantity
        isNotFound
        notFoundAt
        notFoundUser {
          id
          name
        }
        memo
        memoAddedAt
        memoUser {
          id
          name
        }
        isDisplay
        displaySetAt
        displayUser {
          id
          name
        }
        isRestricted
        restrictedAt
        restrictedUser {
          id
          name
        }
        isSkipped
        skippedAt
        skippedUser {
          id
          name
        }
        isStaffNoStock
        staffNoStockAt
        staffNoStockUser {
          id
          name
        }
      }
    }
    product {
      id
      jan
      amazonProducts {
        id
        name
        asin
        latestPrice
        imageUrl
        isMain
        salesCommission
        categoryFee
        fbaShippingFee
        lastKnownPrice {
          price
          at
        }
        keepaProduct {
          boughtPastMonth
          latestPrice
          lastKnownPrice {
            price
            at
          }
          keepaUpdatedAt
        }
      }
    }
  }
  storeAreas {
    id
    name
    edionStores {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EdionProductsGQL extends Apollo.Query<EdionProductsQuery, EdionProductsQueryVariables> {
    document = EdionProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertEdionProductMemoDocument = gql`
    mutation UpsertEdionProductMemo($id: ID!, $memo: String!) {
  upsertEdionProductMemo(id: $id, memo: $memo)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertEdionProductMemoGQL extends Apollo.Mutation<UpsertEdionProductMemoMutation, UpsertEdionProductMemoMutationVariables> {
    document = UpsertEdionProductMemoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PurchaseEdionStockDocument = gql`
    mutation PurchaseEdionStock($id: ID!, $quantity: Int) {
  purchaseEdionStock(id: $id, quantity: $quantity)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PurchaseEdionStockGQL extends Apollo.Mutation<PurchaseEdionStockMutation, PurchaseEdionStockMutationVariables> {
    document = PurchaseEdionStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PurchaseCancelEdionStockDocument = gql`
    mutation PurchaseCancelEdionStock($id: ID!) {
  purchaseCancelEdionStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PurchaseCancelEdionStockGQL extends Apollo.Mutation<PurchaseCancelEdionStockMutation, PurchaseCancelEdionStockMutationVariables> {
    document = PurchaseCancelEdionStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotFoundEdionStockDocument = gql`
    mutation NotFoundEdionStock($id: ID!) {
  notFoundEdionStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotFoundEdionStockGQL extends Apollo.Mutation<NotFoundEdionStockMutation, NotFoundEdionStockMutationVariables> {
    document = NotFoundEdionStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoundEdionStockDocument = gql`
    mutation FoundEdionStock($id: ID!) {
  foundEdionStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoundEdionStockGQL extends Apollo.Mutation<FoundEdionStockMutation, FoundEdionStockMutationVariables> {
    document = FoundEdionStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisplayEdionStockDocument = gql`
    mutation DisplayEdionStock($id: ID!) {
  displayEdionStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisplayEdionStockGQL extends Apollo.Mutation<DisplayEdionStockMutation, DisplayEdionStockMutationVariables> {
    document = DisplayEdionStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisplayCancelEdionStockDocument = gql`
    mutation DisplayCancelEdionStock($id: ID!) {
  displayCancelEdionStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisplayCancelEdionStockGQL extends Apollo.Mutation<DisplayCancelEdionStockMutation, DisplayCancelEdionStockMutationVariables> {
    document = DisplayCancelEdionStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DonkiProductsDocument = gql`
    query DonkiProducts($id: ID, $registrationDate: String) {
  donkiProducts(id: $id, registrationDate: $registrationDate) {
    id
    totalStocks
    registrationDate
    stocks {
      id
      store {
        id
        name
        area {
          id
          name
        }
      }
      stockNum
      price
      createdAt
      operation {
        isPurchased
        purchasedAt
        purchasedUser {
          id
          name
        }
        purchasedQuantity
        isNotFound
        notFoundAt
        notFoundUser {
          id
          name
        }
        memo
        memoAddedAt
        memoUser {
          id
          name
        }
        isDisplay
        displaySetAt
        displayUser {
          id
          name
        }
        isRestricted
        restrictedAt
        restrictedUser {
          id
          name
        }
        isSkipped
        skippedAt
        skippedUser {
          id
          name
        }
        isStaffNoStock
        staffNoStockAt
        staffNoStockUser {
          id
          name
        }
        isConfirmed
        confirmedSetAt
        confirmedUser {
          id
          name
        }
      }
    }
    product {
      id
      jan
      amazonProducts {
        id
        name
        asin
        latestPrice
        imageUrl
        isMain
        keepaProduct {
          boughtPastMonth
        }
      }
    }
  }
  storeAreas {
    id
    name
    donkiStores {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DonkiProductsGQL extends Apollo.Query<DonkiProductsQuery, DonkiProductsQueryVariables> {
    document = DonkiProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertDonkiProductMemoDocument = gql`
    mutation UpsertDonkiProductMemo($id: ID!, $memo: String!) {
  upsertDonkiProductMemo(id: $id, memo: $memo)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertDonkiProductMemoGQL extends Apollo.Mutation<UpsertDonkiProductMemoMutation, UpsertDonkiProductMemoMutationVariables> {
    document = UpsertDonkiProductMemoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PurchaseDonkiStockDocument = gql`
    mutation PurchaseDonkiStock($id: ID!, $quantity: Int) {
  purchaseDonkiStock(id: $id, quantity: $quantity)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PurchaseDonkiStockGQL extends Apollo.Mutation<PurchaseDonkiStockMutation, PurchaseDonkiStockMutationVariables> {
    document = PurchaseDonkiStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PurchaseCancelDonkiStockDocument = gql`
    mutation PurchaseCancelDonkiStock($id: ID!) {
  purchaseCancelDonkiStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PurchaseCancelDonkiStockGQL extends Apollo.Mutation<PurchaseCancelDonkiStockMutation, PurchaseCancelDonkiStockMutationVariables> {
    document = PurchaseCancelDonkiStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotFoundDonkiStockDocument = gql`
    mutation NotFoundDonkiStock($id: ID!) {
  notFoundDonkiStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotFoundDonkiStockGQL extends Apollo.Mutation<NotFoundDonkiStockMutation, NotFoundDonkiStockMutationVariables> {
    document = NotFoundDonkiStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FoundDonkiStockDocument = gql`
    mutation FoundDonkiStock($id: ID!) {
  foundDonkiStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FoundDonkiStockGQL extends Apollo.Mutation<FoundDonkiStockMutation, FoundDonkiStockMutationVariables> {
    document = FoundDonkiStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisplayDonkiStockDocument = gql`
    mutation DisplayDonkiStock($id: ID!) {
  displayDonkiStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisplayDonkiStockGQL extends Apollo.Mutation<DisplayDonkiStockMutation, DisplayDonkiStockMutationVariables> {
    document = DisplayDonkiStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisplayCancelDonkiStockDocument = gql`
    mutation DisplayCancelDonkiStock($id: ID!) {
  displayCancelDonkiStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisplayCancelDonkiStockGQL extends Apollo.Mutation<DisplayCancelDonkiStockMutation, DisplayCancelDonkiStockMutationVariables> {
    document = DisplayCancelDonkiStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmDonkiStockDocument = gql`
    mutation ConfirmDonkiStock($id: ID!) {
  confirmDonkiStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmDonkiStockGQL extends Apollo.Mutation<ConfirmDonkiStockMutation, ConfirmDonkiStockMutationVariables> {
    document = ConfirmDonkiStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmCancelDonkiStockDocument = gql`
    mutation ConfirmCancelDonkiStock($id: ID!) {
  confirmCancelDonkiStock(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmCancelDonkiStockGQL extends Apollo.Mutation<ConfirmCancelDonkiStockMutation, ConfirmCancelDonkiStockMutationVariables> {
    document = ConfirmCancelDonkiStockDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoggingDocument = gql`
    query logging($name: String!, $log: String!) {
  logging(name: $name, log: $log)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoggingGQL extends Apollo.Query<LoggingQuery, LoggingQueryVariables> {
    document = LoggingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterTokenValidateDocument = gql`
    query registerTokenValidate($token: String!) {
  registerTokenValidate(token: $token) {
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterTokenValidateGQL extends Apollo.Query<RegisterTokenValidateQuery, RegisterTokenValidateQueryVariables> {
    document = RegisterTokenValidateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeDocument = gql`
    query me {
  me {
    id
    name
    userRole
    telegramToken
    isStoreManager
    hasRefreshToken
    functions
    userSubRoles
    userGroup {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeWithTelegramDocument = gql`
    query meWithTelegram {
  me {
    id
    userRole
    telegramToken
    isStoreManager
    hasRefreshToken
    userSubRoles
    userTelegram {
      id
      firstName
      lastName
      chatID
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MeWithTelegramGQL extends Apollo.Query<MeWithTelegramQuery, MeWithTelegramQueryVariables> {
    document = MeWithTelegramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersDocument = gql`
    query users($serviceType: String!) {
  users(serviceType: $serviceType) {
    id
    name
    orderInGroup
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    document = UsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopDocument = gql`
    query shop($shopType: ShopType!, $shopCode: String!) {
  shop(input: {shopType: $shopType, shopCode: $shopCode}) {
    shopCode
    shopName
    shopUrl
    latestStartedAt
    latestEndAt
    latestMinPrice
    latestMaxPrice
    totalProductNum
    updatedProductNum
    totalAmazonNum
    updatedAmazonNum
    isDoing
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopGQL extends Apollo.Query<ShopQuery, ShopQueryVariables> {
    document = ShopDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserUpdateShopDocument = gql`
    query userUpdateShop {
  userUpdateShop {
    shopType
    shopCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserUpdateShopGQL extends Apollo.Query<UserUpdateShopQuery, UserUpdateShopQueryVariables> {
    document = UserUpdateShopDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductDetailsDocument = gql`
    query productDetails($shopType: ShopType!, $shopCode: String!, $minPrice: Int!, $maxPrice: Int!, $minGross: Int, $minProfitRate: Int, $hasNewProduct: Boolean, $minRanking: Int) {
  productDetails(
    input: {shopType: $shopType, shopCode: $shopCode, minPrice: $minPrice, maxPrice: $maxPrice, minGross: $minGross, minProfitRate: $minProfitRate, hasNewProduct: $hasNewProduct, minRanking: $minRanking}
  ) {
    jan
    modelNumber
    referencePrice
    amazonProducts {
      name
      asin
      isMain
      latestRanking
      latestPrice
      newSellerNum
      oldSellerNum
      salesBeginDate
      salesCommission
      categoryFee
      fbaShippingFee
    }
    rakutenProducts {
      productCode
      name
      price
      url
      hasStock
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductDetailsGQL extends Apollo.Query<ProductDetailsQuery, ProductDetailsQueryVariables> {
    document = ProductDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserSedoristProductsDocument = gql`
    query userSedoristProducts($keyword: String, $fromDate: String, $toDate: String, $filterUserProduct: FilterUserProduct!, $filterOtherSetting: FilterOtherSetting, $buyingStoreIds: [Int], $buyingStoreTypeId: Int, $filterUserIds: [Int], $amazonCategoryId: Int) {
  userSedoristProducts(
    input: {keyword: $keyword, fromDate: $fromDate, toDate: $toDate, filterUserProduct: $filterUserProduct, filterOtherSetting: $filterOtherSetting, buyingStoreIds: $buyingStoreIds, buyingStoreTypeId: $buyingStoreTypeId, filterUserIds: $filterUserIds, amazonCategoryId: $amazonCategoryId}
  ) {
    id
    user {
      email
      name
    }
    amazonProduct {
      asin
      isMain
      imageUrl
      salesCommission
      salesBeginDate
      categoryFee
      fbaShippingFee
      latestPrice
      lastKnownPrice {
        price
        at
      }
      keepaProduct {
        boughtPastMonth
        latestPrice
        lastKnownPrice {
          price
          at
        }
        keepaUpdatedAt
      }
    }
    product {
      jan
    }
    sku
    productName
    buyingPrice
    sellingPrice
    buyingDate
    buyingStore {
      id
      name
      buyingStoreType {
        id
        name
      }
    }
    condition
    deliveryRoute
    memo
    ipMemo
    isPriceDownInCacheRegister
    isSleeped
    isPriceNegotiation
    topCategory
    isPublic
    createdAt
    sheetData {
      Yamada
      Edion
      Donki
    }
    images {
      ...ProductImageFields
    }
  }
}
    ${ProductImageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserSedoristProductsGQL extends Apollo.Query<UserSedoristProductsQuery, UserSedoristProductsQueryVariables> {
    document = UserSedoristProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPricetarProductsDocument = gql`
    query userPricetarProducts($keyword: String, $fromDate: String, $toDate: String, $filterUserProduct: FilterUserProduct!, $filterOtherSetting: FilterOtherSetting, $buyingStoreIds: [Int], $buyingStoreTypeId: Int, $filterUserIds: [Int], $amazonCategoryId: Int) {
  userPricetarProducts(
    input: {keyword: $keyword, fromDate: $fromDate, toDate: $toDate, filterUserProduct: $filterUserProduct, filterOtherSetting: $filterOtherSetting, buyingStoreIds: $buyingStoreIds, buyingStoreTypeId: $buyingStoreTypeId, filterUserIds: $filterUserIds, amazonCategoryId: $amazonCategoryId}
  ) {
    id
    user {
      email
      name
    }
    amazonProduct {
      asin
      isMain
      imageUrl
      salesCommission
      salesBeginDate
      categoryFee
      fbaShippingFee
    }
    product {
      jan
    }
    sku
    productName
    buyingPrice
    sellingPrice
    orderDate
    deliveryRoute
    memo
    ipMemo
    isPriceDownInCacheRegister
    isSleeped
    isPriceNegotiation
    buyingStore {
      id
      name
      buyingStoreType {
        id
        name
      }
    }
    salesCommission
    condition
    topCategory
    isPublic
    createdAt
    sheetData {
      Yamada
      Edion
      Donki
    }
    images {
      ...ProductImageFields
    }
  }
}
    ${ProductImageFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPricetarProductsGQL extends Apollo.Query<UserPricetarProductsQuery, UserPricetarProductsQueryVariables> {
    document = UserPricetarProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IrisProductDocument = gql`
    query irisProduct {
  irisProduct {
    id
    irisProductCode
    irisSalesResults {
      id
      salesMonth
      salesQuantity
    }
    name
    modelNumber
    color
    referencePrice
    lvonPrice
    quantity
    orderLevel
    outerCaseSizeW
    outerCaseSizeD
    outerCaseSizeH
    kilogram
    discontinuedSchedule
    note
    memo
    priceRevision
    lastImportedAt
    useFba
    updatedAt
    createdAt
    product {
      jan
      amazonProducts {
        asin
        isMain
        latestPrice
        latestRanking
        newSellerNum
        salesCommission
        categoryFee
        fbaShippingFee
      }
    }
    latestHistory {
      lvonPrice
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IrisProductGQL extends Apollo.Query<IrisProductQuery, IrisProductQueryVariables> {
    document = IrisProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BuyingStoresDocument = gql`
    query buyingStores {
  buyingStores {
    id
    name
    buyingStoreType {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BuyingStoresGQL extends Apollo.Query<BuyingStoresQuery, BuyingStoresQueryVariables> {
    document = BuyingStoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BuyingStoreTypesDocument = gql`
    query buyingStoreTypes {
  buyingStoreTypes {
    id
    name
    buyingStores {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BuyingStoreTypesGQL extends Apollo.Query<BuyingStoreTypesQuery, BuyingStoreTypesQueryVariables> {
    document = BuyingStoreTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AmazonCategoriesDocument = gql`
    query amazonCategories($isTop: Boolean) {
  amazonCategories(isTop: $isTop) {
    id
    name
    isTop
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AmazonCategoriesGQL extends Apollo.Query<AmazonCategoriesQuery, AmazonCategoriesQueryVariables> {
    document = AmazonCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BiccameraProductsDocument = gql`
    query biccameraProducts {
  queueBiccameraProducts {
    biccameraItemId
    createdAt
  }
  assertBiccameraProducts {
    canRegisterNewItem
  }
  biccameraProducts {
    id
    productName
    price
    biccameraItemId
    lastCheckedAt
    createdAt
    isDeleted
    totalStockNum
    stocks {
      areaName
      prefecture
      storeName
      hasStock
      stockMark
      note
    }
    product {
      jan
      amazonProducts {
        name
        asin
        isMain
        imageUrl
        latestPrice
        latestRanking
        newSellerNum
        oldSellerNum
        salesBeginDate
        salesCommission
        categoryFee
        fbaShippingFee
        keepaProduct {
          boughtPastMonth
        }
      }
    }
    userBiccameraProduct {
      id
      anotherPrice
      user {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BiccameraProductsGQL extends Apollo.Query<BiccameraProductsQuery, BiccameraProductsQueryVariables> {
    document = BiccameraProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const KojimaProductsDocument = gql`
    query kojimaProducts($areas: [String], $prefectures: [String], $stores: [String]) {
  queueKojimaProducts {
    jan
    createdAt
  }
  assertKojimaProducts {
    canRegisterNewItem
  }
  kojimaProducts(areas: $areas, prefectures: $prefectures, stores: $stores) {
    id
    productName
    price
    lastCheckedAt
    createdAt
    isDeleted
    totalStockNum
    stocks {
      areaId
      areaName
      prefecture
      storeName
      hasStock
      stockValue
      note
    }
    product {
      jan
      amazonProducts {
        name
        asin
        isMain
        imageUrl
        latestPrice
        latestRanking
        newSellerNum
        oldSellerNum
        salesBeginDate
        salesCommission
        categoryFee
        fbaShippingFee
        keepaProduct {
          boughtPastMonth
        }
      }
    }
    userKojimaProduct {
      id
      anotherPrice
      user {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class KojimaProductsGQL extends Apollo.Query<KojimaProductsQuery, KojimaProductsQueryVariables> {
    document = KojimaProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserAmazonNoticeProductsDocument = gql`
    query userAmazonNoticeProducts {
  userAmazonNoticeProducts {
    amazonProduct {
      name
      asin
      isMain
      imageUrl
      latestRanking
      latestPrice
      newSellerNum
      oldSellerNum
      salesBeginDate
      salesCommission
      categoryFee
      fbaShippingFee
      topCategory
      keepaProduct {
        boughtPastMonth
      }
    }
    product {
      jan
    }
    amazonNotifications {
      id
      notifiedAt
      notificationType
      detail
      createdAt
    }
    userAmazonNotification {
      id
      user {
        id
        name
      }
      memo
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserAmazonNoticeProductsGQL extends Apollo.Query<UserAmazonNoticeProductsQuery, UserAmazonNoticeProductsQueryVariables> {
    document = UserAmazonNoticeProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SigninDocument = gql`
    mutation signin($email: String!, $password: String!, $serviceType: String!) {
  signin(input: {email: $email, password: $password, serviceType: $serviceType}) {
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SigninGQL extends Apollo.Mutation<SigninMutation, SigninMutationVariables> {
    document = SigninDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterUserDocument = gql`
    mutation registerUser($token: String!, $salt: String!, $password: String!) {
  registerUser(input: {token: $token, salt: $salt, password: $password}) {
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterUserGQL extends Apollo.Mutation<RegisterUserMutation, RegisterUserMutationVariables> {
    document = RegisterUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SignoutDocument = gql`
    mutation signout {
  signout
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SignoutGQL extends Apollo.Mutation<SignoutMutation, SignoutMutationVariables> {
    document = SignoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshDocument = gql`
    mutation refresh {
  refresh
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshGQL extends Apollo.Mutation<RefreshMutation, RefreshMutationVariables> {
    document = RefreshDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateShopProductsDocument = gql`
    mutation updateShopProducts($shopType: ShopType!, $shopCode: String!, $minPrice: Int!, $maxPrice: Int!, $minGross: Int, $minProfitRate: Int, $hasNewProduct: Boolean, $minRanking: Int) {
  updateShopProducts(
    input: {shopType: $shopType, shopCode: $shopCode, minPrice: $minPrice, maxPrice: $maxPrice, minGross: $minGross, minProfitRate: $minProfitRate, hasNewProduct: $hasNewProduct, minRanking: $minRanking}
  ) {
    shopName
    shopUrl
    latestStartedAt
    latestEndAt
    totalProductNum
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateShopProductsGQL extends Apollo.Mutation<UpdateShopProductsMutation, UpdateShopProductsMutationVariables> {
    document = UpdateShopProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterUserSedoristProductsDocument = gql`
    mutation registerUserSedoristProducts($userSedoristInputs: [UserSedoristProductInput!]) {
  registerUserSedoristProducts(input: $userSedoristInputs)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterUserSedoristProductsGQL extends Apollo.Mutation<RegisterUserSedoristProductsMutation, RegisterUserSedoristProductsMutationVariables> {
    document = RegisterUserSedoristProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterUserPricetarProductsDocument = gql`
    mutation registerUserPricetarProducts($userPricetarInputs: [UserPricetarProductInput!]) {
  registerUserPricetarProducts(input: $userPricetarInputs)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterUserPricetarProductsGQL extends Apollo.Mutation<RegisterUserPricetarProductsMutation, RegisterUserPricetarProductsMutationVariables> {
    document = RegisterUserPricetarProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserPricetarProductsDocument = gql`
    mutation deleteUserPricetarProducts($id: Int!) {
  deleteUserPricetarProducts(input: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserPricetarProductsGQL extends Apollo.Mutation<DeleteUserPricetarProductsMutation, DeleteUserPricetarProductsMutationVariables> {
    document = DeleteUserPricetarProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserSedoristProductsDocument = gql`
    mutation deleteUserSedoristProducts($id: Int!) {
  deleteUserSedoristProducts(input: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserSedoristProductsGQL extends Apollo.Mutation<DeleteUserSedoristProductsMutation, DeleteUserSedoristProductsMutationVariables> {
    document = DeleteUserSedoristProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterBuyingStoreDocument = gql`
    mutation registerBuyingStore($name: String!, $typeId: Int!) {
  registerBuyingStore(name: $name, typeId: $typeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterBuyingStoreGQL extends Apollo.Mutation<RegisterBuyingStoreMutation, RegisterBuyingStoreMutationVariables> {
    document = RegisterBuyingStoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterBuyingStoreTypeDocument = gql`
    mutation registerBuyingStoreType($name: String!) {
  registerBuyingStoreType(name: $name)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterBuyingStoreTypeGQL extends Apollo.Mutation<RegisterBuyingStoreTypeMutation, RegisterBuyingStoreTypeMutationVariables> {
    document = RegisterBuyingStoreTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserSedoristProductDocument = gql`
    mutation updateUserSedoristProduct($id: Int!, $storeId: Int, $memo: String, $ipMemo: String, $isPriceDownInCacheRegister: Boolean, $isPriceNegotiation: Boolean, $isSleeped: Boolean, $isPublic: Boolean) {
  updateUserSedoristProducts(
    id: $id
    buyingStoreId: $storeId
    memo: $memo
    ipMemo: $ipMemo
    isPriceDownInCacheRegister: $isPriceDownInCacheRegister
    isPriceNegotiation: $isPriceNegotiation
    isSleeped: $isSleeped
    isPublic: $isPublic
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserSedoristProductGQL extends Apollo.Mutation<UpdateUserSedoristProductMutation, UpdateUserSedoristProductMutationVariables> {
    document = UpdateUserSedoristProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserPricetarProductDocument = gql`
    mutation updateUserPricetarProduct($id: Int!, $storeId: Int, $memo: String, $ipMemo: String, $isPriceDownInCacheRegister: Boolean, $isPriceNegotiation: Boolean, $isSleeped: Boolean, $isPublic: Boolean) {
  updateUserPricetarProducts(
    id: $id
    buyingStoreId: $storeId
    memo: $memo
    ipMemo: $ipMemo
    isPriceDownInCacheRegister: $isPriceDownInCacheRegister
    isPriceNegotiation: $isPriceNegotiation
    isSleeped: $isSleeped
    isPublic: $isPublic
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserPricetarProductGQL extends Apollo.Mutation<UpdateUserPricetarProductMutation, UpdateUserPricetarProductMutationVariables> {
    document = UpdateUserPricetarProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBuyingStoreDocument = gql`
    mutation deleteBuyingStore($id: Int!) {
  deleteBuyingStore(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBuyingStoreGQL extends Apollo.Mutation<DeleteBuyingStoreMutation, DeleteBuyingStoreMutationVariables> {
    document = DeleteBuyingStoreDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBuyingStoreTypeDocument = gql`
    mutation deleteBuyingStoreType($id: Int!) {
  deleteBuyingStoreType(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBuyingStoreTypeGQL extends Apollo.Mutation<DeleteBuyingStoreTypeMutation, DeleteBuyingStoreTypeMutationVariables> {
    document = DeleteBuyingStoreTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBuyingStoreOrderDocument = gql`
    mutation updateBuyingStoreOrder($typeId: Int!, $ids: [Int!]) {
  updateBuyingStoreOrder(typeId: $typeId, ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBuyingStoreOrderGQL extends Apollo.Mutation<UpdateBuyingStoreOrderMutation, UpdateBuyingStoreOrderMutationVariables> {
    document = UpdateBuyingStoreOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBuyingStoreTypeOrderDocument = gql`
    mutation updateBuyingStoreTypeOrder($ids: [Int!]) {
  updateBuyingStoreTypeOrder(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBuyingStoreTypeOrderGQL extends Apollo.Mutation<UpdateBuyingStoreTypeOrderMutation, UpdateBuyingStoreTypeOrderMutationVariables> {
    document = UpdateBuyingStoreTypeOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrderLevelDocument = gql`
    mutation UpdateOrderLevel($id: Int!, $orderLevel: IrisOrderLevel!) {
  updateIrisOrderLevel(id: $id, orderLevel: $orderLevel)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrderLevelGQL extends Apollo.Mutation<UpdateOrderLevelMutation, UpdateOrderLevelMutationVariables> {
    document = UpdateOrderLevelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIrisMemoDocument = gql`
    mutation updateIrisMemo($id: Int!, $memo: String!) {
  updateIrisMemo(id: $id, memo: $memo)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIrisMemoGQL extends Apollo.Mutation<UpdateIrisMemoMutation, UpdateIrisMemoMutationVariables> {
    document = UpdateIrisMemoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegsiterQueueBiccameraDocument = gql`
    mutation regsiterQueueBiccamera($itemId: String!) {
  registerQueueBiccameraProduct(itemID: $itemId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegsiterQueueBiccameraGQL extends Apollo.Mutation<RegsiterQueueBiccameraMutation, RegsiterQueueBiccameraMutationVariables> {
    document = RegsiterQueueBiccameraDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserBiccameraProductDocument = gql`
    mutation updateUserBiccameraProduct($id: ID!, $anotherPrice: Int!) {
  updateUserBiccameraProduct(id: $id, anotherPrice: $anotherPrice)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserBiccameraProductGQL extends Apollo.Mutation<UpdateUserBiccameraProductMutation, UpdateUserBiccameraProductMutationVariables> {
    document = UpdateUserBiccameraProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegsiterQueueKojimaDocument = gql`
    mutation regsiterQueueKojima($jan: String!) {
  registerQueueKojimaProduct(jan: $jan)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegsiterQueueKojimaGQL extends Apollo.Mutation<RegsiterQueueKojimaMutation, RegsiterQueueKojimaMutationVariables> {
    document = RegsiterQueueKojimaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserKojimaProductDocument = gql`
    mutation updateUserKojimaProduct($id: ID!, $anotherPrice: Int!) {
  updateUserKojimaProduct(id: $id, anotherPrice: $anotherPrice)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserKojimaProductGQL extends Apollo.Mutation<UpdateUserKojimaProductMutation, UpdateUserKojimaProductMutationVariables> {
    document = UpdateUserKojimaProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIrisFbaDocument = gql`
    mutation updateIrisFba($id: Int!, $useFba: Boolean!) {
  updateIrisFba(id: $id, useFba: $useFba)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIrisFbaGQL extends Apollo.Mutation<UpdateIrisFbaMutation, UpdateIrisFbaMutationVariables> {
    document = UpdateIrisFbaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExchangeRefreshTokenDocument = gql`
    mutation exchangeRefreshToken($sellingPartnerID: String!, $spapiOauthCode: String!, $state: String!) {
  exchangeRefreshToken(
    sellingPartnerID: $sellingPartnerID
    spapiOauthCode: $spapiOauthCode
    state: $state
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExchangeRefreshTokenGQL extends Apollo.Mutation<ExchangeRefreshTokenMutation, ExchangeRefreshTokenMutationVariables> {
    document = ExchangeRefreshTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteKojimaProductDocument = gql`
    mutation deleteKojimaProduct($id: ID!) {
  deleteKojimaProduct(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteKojimaProductGQL extends Apollo.Mutation<DeleteKojimaProductMutation, DeleteKojimaProductMutationVariables> {
    document = DeleteKojimaProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBiccameraProductDocument = gql`
    mutation deleteBiccameraProduct($id: ID!) {
  deleteBiccameraProduct(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBiccameraProductGQL extends Apollo.Mutation<DeleteBiccameraProductMutation, DeleteBiccameraProductMutationVariables> {
    document = DeleteBiccameraProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserAmazonNotificationsDocument = gql`
    query userAmazonNotifications($createdAtFrom: String) {
  userAmazonNotifications(createdAtFrom: $createdAtFrom) {
    id
    user {
      id
      name
    }
    amazonProduct {
      id
      asin
      name
      imageUrl
      isMain
      latestPrice
      latestRanking
      newSellerNum
      oldSellerNum
      keepaProduct {
        boughtPastMonth
      }
    }
    memo
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserAmazonNotificationsGQL extends Apollo.Query<UserAmazonNotificationsQuery, UserAmazonNotificationsQueryVariables> {
    document = UserAmazonNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterUserAmazonNotificationDocument = gql`
    mutation registerUserAmazonNotification($asins: [String!]!) {
  registerUserAmazonNotification(asins: $asins)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterUserAmazonNotificationGQL extends Apollo.Mutation<RegisterUserAmazonNotificationMutation, RegisterUserAmazonNotificationMutationVariables> {
    document = RegisterUserAmazonNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertUserAmazonNotificationDocument = gql`
    mutation upsertUserAmazonNotification($asin: String!, $memo: String) {
  upsertUserAmazonNotification(asin: $asin, memo: $memo)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertUserAmazonNotificationGQL extends Apollo.Mutation<UpsertUserAmazonNotificationMutation, UpsertUserAmazonNotificationMutationVariables> {
    document = UpsertUserAmazonNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserAmazonNotificationDocument = gql`
    mutation removeUserAmazonNotification($asin: String!) {
  removeUserAmazonNotification(asin: $asin)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserAmazonNotificationGQL extends Apollo.Mutation<RemoveUserAmazonNotificationMutation, RemoveUserAmazonNotificationMutationVariables> {
    document = RemoveUserAmazonNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckSpapiTokenValidDocument = gql`
    query checkSpapiTokenValid {
  checkSpapiTokenValid {
    valid
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckSpapiTokenValidGQL extends Apollo.Query<CheckSpapiTokenValidQuery, CheckSpapiTokenValidQueryVariables> {
    document = CheckSpapiTokenValidDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AmazonPriceTracksDocument = gql`
    query amazonPriceTracks {
  amazonPriceTrack {
    id
    thresholdPrice
    amazonProduct {
      asin
      name
      imageUrl
      latestPrice
      latestRanking
      newSellerNum
      oldSellerNum
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AmazonPriceTracksGQL extends Apollo.Query<AmazonPriceTracksQuery, AmazonPriceTracksQueryVariables> {
    document = AmazonPriceTracksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpsertAmazonPriceTrackDocument = gql`
    mutation upsertAmazonPriceTrack($asin: String!, $thresholdPrice: Int!) {
  upsertAmazonPriceTrack(asin: $asin, thresholdPrice: $thresholdPrice)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpsertAmazonPriceTrackGQL extends Apollo.Mutation<UpsertAmazonPriceTrackMutation, UpsertAmazonPriceTrackMutationVariables> {
    document = UpsertAmazonPriceTrackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAmazonPriceTrackDocument = gql`
    mutation deleteAmazonPriceTrack($id: Int!) {
  deleteAmazonPriceTrack(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAmazonPriceTrackGQL extends Apollo.Mutation<DeleteAmazonPriceTrackMutation, DeleteAmazonPriceTrackMutationVariables> {
    document = DeleteAmazonPriceTrackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAmazonProductsDocument = gql`
    mutation deleteAmazonProducts($asins: [String!]!) {
  deleteAmazonProducts(asins: $asins)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAmazonProductsGQL extends Apollo.Mutation<DeleteAmazonProductsMutation, DeleteAmazonProductsMutationVariables> {
    document = DeleteAmazonProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }